import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private readonly currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    isRefreshingToken: boolean;

    constructor() {
        let storedUser = localStorage.getItem('currentUser');
        if (storedUser) {
            storedUser = JSON.parse(storedUser);
        }
        this.currentUserSubject = new BehaviorSubject<any>(storedUser);
        this.currentUser = this.currentUserSubject.asObservable();
        this.isRefreshingToken = false;
        this.checkCurrentUser();
    }

    checkCurrentUser() {
        const storedUser = localStorage.getItem('currentUser');
        if (!storedUser && this.currentUserSubject.value) {
          // empty if
        
            
        }
    }

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }

    isLoggedIn() : Observable<boolean> {
        return this.currentUserSubject.asObservable();
    }

    login(result: string) {
        localStorage.setItem('currentUser', JSON.stringify(result));
        this.currentUserSubject.next(result);
        return result;
    }

    changeAccessToken() {
        console.log(this.currentUserSubject.value.access_token);
        this.currentUserSubject.value.access_token = this.currentUserSubject.value.access_token+'fsdfsdf';        
        console.log(this.currentUserSubject.value);
        this.currentUserSubject.next(this.currentUserSubject.value);
    }

}